module.exports = __webpack_public_path__ + "media/Axel_Pairing-Mode_Light_animation.b8ecc3fe.mp4";